import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input, Row, Col, DatePicker, Upload, Space, Button } from 'antd';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import TextArea from 'antd/lib/input/TextArea';
import { AddRecord } from '../../layouts/AddRecord';
import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import TagInput from '../Products/TagInput';
import { InfoCircleOutlined, LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import getSampleVideoType from '../../hooks/getSampleVideoType';
import AddPhoto from '../../assets/images/add.png';
import getBoxIngType from '../../hooks/getBoxIngType';
import LoaderImage from '../LoaderImage';
import MainOrderViewModal from './MainOrderViewModal';
import moment from 'moment';
// import RequestImageWall from './RequestImageWall';

const ViewModal = ({ showAddModal, setShowAddModal, setIsRender, modalLoader, shopPartnerRecords }) => {
  console.log('shopPartnerRecords--->', shopPartnerRecords);

  const { t } = useTranslation(['common']);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [uploadVideo, setuploadVideo] = useState('');
  const [contentType, setContentType] = useState();
  const [uplVid, setuplVid] = useState(true);
  const sampleVideoRes = getSampleVideoType();
  const [imageuploading, setimageuploading] = useState(false);
  const [uploadImage, setuploadImage] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [showSingleMainOrder, setShowSingleMainOrder] = useState([]);
  const [subOrdersData, setSubOrdersData] = useState([]);
  const [ecomId, setEcomId] = useState('');
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [subOrderObj, setSubOrderObj] = useState({});
  const [commentsData, setCommentsData] = useState([]);

  // const [fileList, setFileList] = useState([]);

  let headers = getHeaders();

  const [form] = Form.useForm();

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    // reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file, e) => {
    console.log(file);

    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      console.log('setting image type');
      setContentType('img');
    } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    console.log('file Checked');
    const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
    if (!isLt2M) {
      setLargeFile(true);
      message.error('Image must smaller than 20MB!');
    }
    console.log('message');
    return isJpgOrPng && isLt2M;
  };

  const handleuploadChange = (info) => {
    setuploadVideo('');

    console.log(info);
    if (info.file.status === 'uploading') {
      return;
    }
    if (info.file.status === 'done') {
      info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
      info.file ? setuploadVideo(info.file.response.result.data.Location) : ' ';
      getBase64(info.file.originFileObj, (url) => {
        setuplVid(false);
      });
    }
  };

  let navigate = useNavigate();

  const [uploadObj, setUploadObj] = useState({});
  function goBack() {
    navigate('/boxtypeing/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  const user = JSON.parse(localStorage.getItem('user'));

  const uploadData = async (userDetails) => {
    setLoading(true);
    let userId = user?.result.data.user.userId;
    userDetails.userId = userId;
    try {
      const res = await axios.post(`${app.URL}/api/v1/admin/boxtypeing/add`, userDetails, { headers: getHeaders() });
      setLoading(false);
      setShow(false);

      if (res.data.result.success) {
        form.resetFields();
        setuploadImage([]);
        setFileList([]);
        setTimeout(() => {
          setShowAddModal(false);
          setIsRender(true);
        }, 1000);

        // navigate('boxtypeing/view');
        message.success(res.data.result.msg);

        // setTimeout(goBack, 500);
      } else if (!res.data.result.success) {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setShow(false);

      if (err) console.log(err.response.data.message);
      else return;
    }
  };

  const onFinish = (values) => {
    console.log('On Finish', values);

    const boxObj = {
      ...values,
      image: uploadImage,
    };
    console.log('Box Obj', boxObj);
    uploadData(boxObj);
  };

  const submitData = async () => {
    console.log('Submit Data func', uploadObj);
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  // const handleuploadImage = (info) => {
  //   console.log('Info', info);
  //   if (info.file.status === 'uploading') {
  //     setimageuploading(true);
  //   }
  //   if (info.file.status === 'done') {
  //     // Get this url from response in real world.
  //     info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
  //     info.file ? setuploadImage(info.file.response.result.data.Location) : ' ';
  //     setimageuploading(false);
  //   }
  // };

  // const subViewModal = (id) => {
  //   console.log('iddd-->', id);
  //   setShowSingleMainOrder(true);
  //   setEcomId(id);
  // };
  const subViewModal = async (id) => {
    setIsModalLoading(true); // Show loader
    setShowSingleMainOrder(true); // Open the modal
    setEcomId(id); // Set the order ID
    // let convertedObj;

    try {
      const response = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${id}`, {
        headers: getHeaders(),
      });
      console.log('Order Data:', response.data.result.data);
      setSubOrdersData(response.data.result.data?.orderDetails || []); // Update modal data

      setSubOrderObj(response?.data?.result?.data); // Update modal data
      setCommentsData(response?.data?.result?.data.comments); // Update modal data
    } catch (error) {
      console.error('Failed to fetch order data:', error);
    } finally {
      setIsModalLoading(false); // Hide loader
    }
  };

  console.log('Upload Image', uploadImage);
  return (
    <>
      {ecomId && (
        <MainOrderViewModal
          isVisible={showSingleMainOrder}
          setIsVisible={setShowSingleMainOrder}
          ecomOrderNo={subOrderObj.ecomOrderNo}
          ecomOrderCreatedData={moment(subOrderObj.createdAt).format('MM-DD-YYYY')}
          productTotalAmount={subOrderObj.totalProductAmount}
          mainOrderGrandTotal={subOrderObj.grandTotalAmount}
          mainOrderShipmentAmount={subOrderObj.totalShipmentCharges}
          mainOrderTotalAmount={subOrderObj.totalShipmentAmount}
          isLoading={isModalLoading}
          setIsLoading={setIsModalLoading}
          subOrdersData={subOrdersData}
          totalProductAmount={subOrderObj.totalProductAmount}
          ecomOrderId={ecomId}
          comments={commentsData}
          isApiCallAble={false}
        />
      )}

      <div
        className={`modal fade ${showAddModal ? 'show' : ''}`}
        id='appointmentModal'
        tabIndex='-1'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
        style={{
          backdropFilter: 'blur(5px)',
          display: showAddModal ? 'block' : 'none',
        }}
        onClick={(e) => {
          if (e.target.classList.contains('modal')) {
            setShowAddModal(false); // Close the modal when clicking outside of it
          }
        }}
      >
        <div className={`modal-dialog position-relative modal-dialog-centered modal-xl `}>
          <div className='modal-content'>
            {/* <button
            type='button'
            className='btn-close btn-success bg-dark position-absolute top-0 end-0'
            onClick={() => setShowAddModal(false)}
            style={{
              marginTop: '-2rem',
              color: 'black',
            }}
            data-bs-dismiss='modal'
            aria-label='Close'
          ></button> */}
            {modalLoader ? (
              <LoaderImage />
            ) : (
              <div className='modal-body p-3'>
                <div
                  className='row table-scrollbar mr-0'
                  style={{
                    overflowX: 'auto',
                  }}
                >
                  <table id='customers'>
                    <thead>
                      <tr>
                        <th>Session Id</th>

                        <th>Order No.</th>
                        <th>Patient Name</th>
                        <th>Product Name</th>
                        <th>Message</th>
                        <th>Date</th>
                        {/* <th>Shop Partner Date</th> */}
                        {/* <th>Partner</th> */}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shopPartnerRecords.map((tableValues) => (
                        <tr>
                          <td>{tableValues.sessionId !== null ? tableValues.sessionId : '-'}</td>

                          <td>{tableValues.ecomOrderNo !== null ? tableValues.ecomOrderNo : '-'}</td>

                          <td
                          // onClick={() => {
                          //   setDetailModalShow(true);
                          //   fetchInventoryByBatchId(tableValues.batchId);
                          // }}
                          // className='batchlink'
                          >
                            {tableValues.firstName !== null ? tableValues.firstName : '-'} {tableValues.lastName !== null ? tableValues.lastName : ' '}
                          </td>
                          <td>{tableValues.productName !== null ? tableValues.productName : '-'}</td>
                          <td>{tableValues.message !== null ? tableValues.message : '-'}</td>
                          <td>{tableValues.createdAt !== null ? moment(tableValues.createdAt).format('MM-DD-YYYY HH:mm') : '-'}</td>

                          <td>
                            {tableValues.ecomOrderId !== null ? (
                              <button className='btn text-light mx-2' onClick={() => subViewModal(tableValues.ecomOrderId)}>
                                View{' '}
                              </button>
                            ) : (
                              '-'
                            )}
                            {/* <button disabled={batchID === tableValues.batchId} className='btn mx-2' onClick={() => handleRePrint(tableValues.batchId)}>
                        {printLoader && batchID === tableValues.batchId ? (
                          <LoadingOutlined
                            style={{
                              fontSize: '1.5rem',
                              color: 'white',
                            }}
                          />
                        ) : (
                          <PrinterOutlined
                            style={{
                              fontSize: '1.5rem',
                              color: 'white',
                            }}
                          />
                        )}
                      </button> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* {shopPartnerRecords?.map((record) => (
                
              ))} */}
                <button
                  onClick={() => {
                    setShowAddModal(false);
                  }}
                  type='button'
                  className={`btn btn-primary button patient-cancel-btn  ${location.pathname === '/patient/create' ? 'col-md-3' : 'col-md-4'} mx-md-2 mr-2 mb-2`}
                >
                  Close
                </button>
                {/* <button type='primary' className={`btn btn-primary button ${location.pathname === '/patient/create' ? 'col-md-3' : 'col-md-4'}  mb-2`} htmlType='submit'>
                Save
              </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewModal;
